/* eslint-disable no-lone-blocks */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import "./status-button.styles.scss";

const Status = ({
  status,
  statusEmail,
  statusEmailDateTime,
  customStatus,
  lastActivity,
}) => {
  let hasCustomStatus = false;
  let trimmedCustomStatus = customStatus;

  if (
    (customStatus &&
      status != "Approved" &&
      status != "Completed" &&
      status != "Cancelled") ||
    ((customStatus == "Completed - Successfully" ||
      customStatus?.toLowerCase()?.includes("complete")) &&
      status == "Approved")
  ) {
    hasCustomStatus = true;
  }
  if (hasCustomStatus && customStatus?.length > 18) {
    trimmedCustomStatus = trimmedCustomStatus.substring(0, 18) + "...";
  }
  let statusDisplay = "";
  let statusText = "";
  {
    (status === "Not Started" || status === "Assigned") &&
      (statusText = "Not Started") &&
      (statusDisplay = (
        <div className="status not-started">
          <p>{hasCustomStatus ? trimmedCustomStatus : "Not Started"}</p>
        </div>
      ));
  }
  {
    {
      customStatus !== "Completed" &&
        (status === "In Progress" ||
          status === "InProgress" ||
          status === "Declined") &&
        (statusText = "In Progress") &&
        (statusDisplay = (
          <div className="status in-progress">
            <p>{hasCustomStatus ? trimmedCustomStatus : "In Progress"}</p>
          </div>
        ));
    }
    {
      customStatus === "Completed" &&
        (status === "In Progress" ||
          status === "InProgress" ||
          status === "Declined") &&
        (statusText = "In Progress") &&
        (statusDisplay = (
          <div className="status completed">
            <p>{hasCustomStatus ? trimmedCustomStatus : "In Progress"}</p>
          </div>
        ));
    }
  }
  {
    status === "Submitted" &&
      (statusText = "Submitted") &&
      (statusDisplay = (
        <div className="status submitted">
          <p>{hasCustomStatus ? trimmedCustomStatus : "Submitted"}</p>
        </div>
      ));
  }
  {
    (status === "AwaitingApproval" ||
      status === "Awaiting Approval" ||
      status === "Pending review" ||
      status === "PendingReview" ||
      status === "Pending Review" ||
      status === "Assigned - Pending review" ||
      status === "Pending Approval" ||
      status === "PendingApproval") &&
      (statusText = "Pending Approval") &&
      (statusDisplay = (
        <div className="status awaiting-approval">
          <p>{hasCustomStatus ? trimmedCustomStatus : "Pending Approval"}</p>
        </div>
      ));
  }
  {
    status === "Inactive" &&
      (statusText = "Inactive") &&
      (statusDisplay = (
        <div className="status inactive">
          <p>{hasCustomStatus ? trimmedCustomStatus : "Inactive"}</p>
        </div>
      ));
  }
  {
    (status === "Completed" || status === "Approved") &&
      (statusText = "Completed") &&
      (statusDisplay = (
        <div className="status completed">
          <p>{hasCustomStatus ? trimmedCustomStatus : "Closed"}</p>
        </div>
      ));
  }
  {
    status === "Cancelled" &&
      (statusText = "Cancelled") &&
      (statusDisplay = (
        <div className="status cancelled">
          <p>{hasCustomStatus ? trimmedCustomStatus : "Cancelled"}</p>
        </div>
      ));
  }
  {
    status === "Archived" &&
      (statusText = "Archived") &&
      (statusDisplay = (
        <div className="status not-started">
          <p>{hasCustomStatus ? trimmedCustomStatus : "Archived"}</p>
        </div>
      ));
  }
  {
    status === "Active" &&
      (statusText = "Active") &&
      (statusDisplay = (
        <div className="status active">
          <p>{hasCustomStatus ? trimmedCustomStatus : "Active"}</p>
        </div>
      ));
  }
  {
    status === "Overdue" &&
      (statusText = "Overdue") &&
      (statusDisplay = (
        <div className="status cancelled">
          <p>{hasCustomStatus ? trimmedCustomStatus : "Overdue"}</p>
        </div>
      ));
  }

  return (
    <OverlayTrigger
      placement={"top"}
      delay={{ show: 150, hide: 150 }}
      overlay={<Tooltip>{hasCustomStatus ? customStatus : statusText}</Tooltip>}
    >
      <div className="status-bar">{statusDisplay}</div>
    </OverlayTrigger>
  );
};

export default Status;
